var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"text-area text-area--default",attrs:{"rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"blur":function($event){return _vm.$emit('blur')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }